// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p7-c";
export var backButton = "_p7-4";
export var backIcon = "_p7-5";
export var chevronShortcut = "_p7-6";
export var container = "_p7-1";
export var editor = "_p7-8";
export var editorWrapper = "_p7-7";
export var prefix = "_p7-2";
export var searchIcon = "_p7-3";
export var suffix = "_p7-9";
export var suffixContent = "_p7-a";
export var suffixText = "_p7-b";
export var wrapper = "_p7-0";